export default function ClickAppBannerEventModel(storeName: string) {
    return {
        storeName: storeName,
    }
}